import { render, staticRenderFns } from "./SocialBar.vue?vue&type=template&id=6666231d&scoped=true"
import script from "./SocialBar.vue?vue&type=script&lang=js"
export * from "./SocialBar.vue?vue&type=script&lang=js"
import style0 from "./SocialBar.vue?vue&type=style&index=0&id=6666231d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6666231d",
  null
  
)

export default component.exports